const ErrorExclamation = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <circle cx={9.999} cy={10} r={8.333} fill="#BC3636" />
    <path
      fill="#fff"
      d="m10.805 5.217-.156 6.686H9.308l-.163-6.686h1.66ZM9.1 13.954c0-.24.078-.439.234-.6.16-.164.382-.247.664-.247.278 0 .497.083.658.248.16.16.24.36.24.599a.82.82 0 0 1-.24.592c-.161.16-.38.241-.658.241-.282 0-.503-.08-.664-.24a.831.831 0 0 1-.234-.593Z"
    />
  </svg>
)
export default ErrorExclamation
